import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { muiTheme } from "./theme/themeConfiguration";
import { i18n } from "./translations/i18n";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { createRoot } from "react-dom/client";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { TssCacheProvider } from "tss-react";

const muiCache = createCache({
    key: "mui",
    prepend: true,
});

const tssCache = createCache({
    key: "tss",
});

const container = document.getElementById("app");
const root = createRoot(container!);

root.render(
    <BrowserRouter>
        <CacheProvider value={muiCache}>
            <TssCacheProvider value={tssCache}>
                <MuiThemeProvider theme={muiTheme}>
                    {/* @ts-expect-error - I18nextProvider typing mismatch with current react-i18next version */}
                    <I18nextProvider i18n={i18n}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <App />
                        </LocalizationProvider>
                    </I18nextProvider>
                </MuiThemeProvider>
            </TssCacheProvider>
        </CacheProvider>
    </BrowserRouter>
);
